<div class="tiime-overlay-container" cdkScrollable>
  @if (isLoading) {
    <mat-progress-spinner
      class="dialog-spinner"
      diameter="25"
      color="primary"
      mode="indeterminate"
    ></mat-progress-spinner>
  }
  <ng-content select="[tiimeOverlayHeader]"></ng-content>
  <ng-content select="[tiimeOverlayContent]"></ng-content>
  <ng-content select="[tiimeOverlayFooter]"></ng-content>
</div>
